import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestDeleteAffinityRule } from "./deleteAffinityRule.request";

const useDeleteAffinityRule = (
  options?: MutationOptions<{ ok: true }, ApiServiceError<ApiError>, string>
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: requestDeleteAffinityRule,
    ...options,
    onSuccess: (data, variables, ctx) => {
      void queryClient.invalidateQueries({
        queryKey: ["recommendation", "affinity"]
      });
      options?.onSuccess?.(data, variables, ctx);
    }
  });
};

export default useDeleteAffinityRule;
